export class BaseResult {
  public success: boolean = false;
  public error: boolean = false;
  public errorMessage: string = '';
  public statusCode: number = 0;

  constructor(init?: Partial<BaseResult>) {
    Object.assign(this, init);
  }
}
